import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
